import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppHelperService } from '../../../app/services/app-helper.service';
import { ContentHelper } from 'libs-content-helper';
import { ProductTocService } from 'modules/shared-postlogin/services/product-toc.service';
import { LtiHelperService } from '../../services/lti-helper.service';
import { LTIAssignmentsSharedService } from 'modules/teacher/services/lti-assignments-shared.service';
import { LoaderService } from 'modules/app/services/loader.service';
import { AssignmentViewService } from 'modules/teacher/services/assignment-view.service';

declare let $: any;

@Component({
    selector: 'lti-link-path',
    templateUrl: './lti-link-path.template.html',
    styleUrls: ['./lti-link-path.style.scss'],
    standalone: false
})
export class LtiLinkPath implements OnInit {
  @Input() learningpathVisible : boolean = true;
  @Output() learningpathVisibleChange = new EventEmitter<boolean>();
  @Input() noOfCheckedItems : number = 0;
  @Output() noOfCheckedItemsChange = new EventEmitter<number>();
  @Input() tocArray : any[];
  @Output() tocArrayChange = new EventEmitter<any[]>();
  @Input() selectedItem : any;
  @Input() productMeta : any;
  @Input() classmeta : any;
  @Input() assignmentData  : any;
  @Input() itemsAlreadyAssigned: any;
  @Input() classGroupData: any;
  @Input() productBundleDetails: any;
  @Input() spaceId: string;
  @Input() classId: string;
  @Input() showActivity: boolean;
  @Input() ltiDeepLinkingMode: boolean;
  @Input() assignmentsLOCount: number;
  @Output() showActivityChange = new EventEmitter<boolean>();
  @Input() totalAssignmentsCount : number;
  @Input('productWiseClassAssignments') customLinks : any;
  @Output() assignmentStatus = new EventEmitter<boolean>();
  
  unitView : boolean = true;
  manageCustomLinks : boolean = false;
  public contentHelper = ContentHelper;
  activityView : boolean = false;
  tocFolderDepth: number = 0;
  showProductTitle: boolean = true
  previousActivity: any;
  radioButtons: boolean = false;
  noOfCheckedUnits: number = 0;
  isSpeakingCompanion: boolean = false;
  public deeplinkOption: string = 'unit';
  public totalItemsInProduct: number = 0;
  public totalUnitFoldersInProduct: number = 0;
  public totalUnitResourcesInProduct: number = 0;
  showDeepLinkLoader: boolean = false;
  classProduct:any;
  selectedTestActivities:any = [];
  public selectedItemsUpdatedAfterInitiation: any = {};
  unitActivityCountHash = {};
  totalAssignmentsLimit: number = 150;
  isCustomDeeplinksEnabled: boolean = false;
  selectedCustomLink: any;
  public imageBasePath: string = IMAGES_BASEPATH;
  private readonly assignmentsLOLimitInClass: number = Number.parseInt(ASSIGNMENTS_LO_LIMIT_IN_CLASS);
  public isCustomLinksJourney: boolean = true;
  public isAssignmentsLOLimitReached: boolean = false;

  @ViewChild('assignmentsLOLimitWarningModalButton', { static: false }) assignmentsLOLimitWarningModalButton: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute, 
    private appHelperService: AppHelperService,
    private assignmentViewService: AssignmentViewService,
    private ltiHelperService: LtiHelperService,
    private productTocService: ProductTocService,
    private ltiAssignmentsSharedService: LTIAssignmentsSharedService,
    private loaderService: LoaderService, // Used in service do not remove
    private router: Router // Used in service do not remove
    ) { }

  ngOnInit() {
    if(!this.ltiDeepLinkingMode) return;
    this.tocFolderDepth = this.productTocService.getTocNodeCount(this.tocArray);
    this.classProduct = this.productBundleDetails.products.find((product) => product['dls-product'].code === this.productMeta.productcode);
    // checking if the product is Speaking Companion
    this.isSpeakingCompanion = this.classProduct?.['learning-path']?.version === '4';
    let assignability = this.classProduct.assignability;
    this.isCustomDeeplinksEnabled = this.activatedRoute.snapshot.data.resolveData.productData.ltiCustomDeeplinkData.isCustomDeeplinks ? true : false;
    this.createCustomLinksData();

    if(assignability && assignability['item-limit']) {
      let itemLimit = assignability['item-limit'];
      if(itemLimit === 1) {
        this.radioButtons = true;
      }
    }

    if(this.tocFolderDepth === 0) {
      this.unitView = false;
      this.activityView = true;
      this.tocArray = this.tocArray.filter((activity) => {
        if(this.itemsAlreadyAssigned[activity['item-code']]) {
            activity.alreadyAssigned = true;
        }
        return true;
      });
      this.totalItemsInProduct = this.tocArray.length;
    } else {
      if(this.tocFolderDepth === 1) {
        this.unitView = false;
      }
      this.tocArray.forEach(unit => {
        let unitLessons = [];
        unitLessons = this.productTocService.getLastFolderData(unit);
        unitLessons.forEach(lesson => {
          lesson.checkedItems = 0;
          lesson.itemsDisabled = 0; // Kept as is, to not impact existing functionality in lti-assignments-shared.service.ts
          let allItemsAssigned = true;
          if(lesson.items.length === 0) {
            allItemsAssigned = false;
          }
          lesson.items = lesson.items.filter(item => {
              if(!this.itemsAlreadyAssigned[item['item-code']]) {
                allItemsAssigned = false;
              } else {
                  item.alreadyAssigned = true;
              }
              return true;
          });
          lesson.showPreviousAssignedText = allItemsAssigned;
        })
      })
    }
    this.totalUnitFoldersInProduct = this.tocArray.filter(unit => unit['item-type'] === 'folder').length;
    // In case of Level 1 Speaking companion, we get items of type resource - so counting those resources here
    this.totalUnitResourcesInProduct = this.tocArray.filter(unit => unit['item-type'] === 'resource').length;
    this.isAssignmentsLOLimitReached = this.assignmentsLOCount >= this.assignmentsLOLimitInClass;
  }

  updateSelectContentView(deletedCustomLink) {
    deletedCustomLink.itemsArray.forEach(activityItem => {
      this.tocArray.forEach(unit => {
        // Adding handling for activities preseent at unit level(Level 1)
        if(unit['item-type'] === 'resource' && activityItem['item-code'] === unit['item-code']) {
          this.decrementAssignmentCount(unit);
        }
        let unitLessons = [];
        unitLessons = this.productTocService.getLastFolderData(unit);
        unitLessons.forEach(lesson => {
          lesson.items.forEach(item => {
            if (activityItem['item-code'] === item['item-code']) {
              this.decrementAssignmentCount(item, lesson);
            }
          });
        })
      })
    })
  }

  private decrementAssignmentCount(item: any, lesson?: any) {
    const assignedItem = this.itemsAlreadyAssigned[item['item-code']];
    if (!assignedItem) return;
    assignedItem.count--;
    this.assignmentsLOCount--;
    if (assignedItem.count === 0) {
      delete this.itemsAlreadyAssigned[item['item-code']];
      item.alreadyAssigned = false;
      if (lesson) {
        lesson.showPreviousAssignedText = false;
      }
    }
  }

  deleteAssignment() {
    this.ltiHelperService.deleteAssignmentFromClass(this.spaceId, this.classId, this.selectedCustomLink.assigned_path_id).subscribe((res: any) => {
      if (res.success) {
        //removing 'deleted custom link' from the list
        this.customLinks = this.customLinks.filter((customLink) => customLink.assigned_path_id !== this.selectedCustomLink.assigned_path_id);
        //enabling activities/lessons back after the respective assignment got deleted
        this.updateSelectContentView(this.selectedCustomLink);
        //sent 'customLinkDeleted=true' in next to show 'assignment deletion success banner' in template
        this.assignmentViewService.deletedAssignmentSubject.next({ customLinkDeleted: true });
        //sending 'true' i.e. "assignment is deleted" to parent component
        this.assignmentStatus.emit(true);
        this.selectedCustomLink = false;
        this.totalAssignmentsCount--;
        this.isAssignmentsLOLimitReached = this.assignmentsLOCount >= this.assignmentsLOLimitInClass;
      }
    });
  }

  backToSelectContentView() {
    this.manageCustomLinks = false;
    this.selectedCustomLink = undefined;
  }

  //custom sort function (ascending order)
  customSortIgnoreCase(array) {
    return array.sort((a, b) => {
      if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
      if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
      return 0;
    });
  }

  createCustomLinksData() {
    this.customLinks.forEach((entity) => {
      entity["items"] = JSON.parse(JSON.stringify(entity.items));
      const tree = [];
      let isScorableActivityPresent = false;
      
      entity.items.forEach((item) => {
        const itemCodeParts = item['item-code'].split('/');
        const itemCode = item['item-code'];
        const customLinkDepth = itemCodeParts.length;
        if(customLinkDepth === 1) {
          // Case 1: Activity only (no unit, no lesson)
          const activity = this.tocArray.find(activity => activity['item-code'] === itemCode);
          if (activity?.['item-type'] === 'resource') {
            tree.push({
              name: activity.name,
              'item-type': 'resource',
              'item-code': itemCode,
            });
            if(!isScorableActivityPresent) {
              isScorableActivityPresent = this.isActivityScorable(activity);
            }
          }
        } else if (customLinkDepth === 2) {
          // Case 2: Unit -> Activity (no lesson)
          const unitCode = itemCodeParts[0];
          const unit = this.tocArray.find(unit => unit['item-code'] === unitCode);
          
          if (unit?.['item-type'] === 'folder') {
            let unitNode = tree.find(node => node['item-code'] === unitCode);
            
            if (!unitNode) {
              unitNode = {
                name: unit.name,
                'item-type': 'folder',
                'item-code': unitCode,
                items: [],
              };
              tree.push(unitNode);
            }
            // Find activity directly under unit
            const activity = unit.items?.find(activity => activity['item-code'] === itemCode);
            if (activity?.['item-type'] === 'resource') {
              unitNode.items.push({
                name: activity.name,
                'item-type': 'resource',
                'item-code': itemCode,
              });
              if(!isScorableActivityPresent) {
                isScorableActivityPresent = this.isActivityScorable(activity);
              }
            }
          }
        } else { 
          // Case 3: Unit -> Lesson -> Activity (customLinkDepth === 3)
          let unitCode = item['item-code'].split('/')[0];
          let lessonCode = unitCode + '/' + item['item-code'].split('/')[1];
          let activityCode = lessonCode + '/' + item['item-code'].split('/')[2];
          this.tocArray.some((unit): any => {
            if (unit['item-code'] == unitCode) {
              let unitNode = tree.find(function (node) {
                return node['item-code'] === unitCode;
              });

              // If the unit doesn't exist, create it.
              if (!unitNode) {
                unitNode = {
                  name: unit.name,
                  'item-type': 'folder',
                  'item-code': unitCode,
                  items: [],
                };
                tree.push(unitNode);
              }

              unit.items?.forEach((lesson) => {
                if (lesson['item-code'] == lessonCode) {
                  // Check if the lesson already exists in the unit.
                  let lessonNode = unitNode.items.find(function (node) {
                    return node['item-code'] === lessonCode;
                  });

                  // If the lesson doesn't exist, create it.
                  if (!lessonNode) {
                    lessonNode = {
                      'item-type': 'folder',
                      'item-code': lessonCode,
                      name: lesson.name,
                      items: [],
                    };
                    unitNode.items.push(lessonNode);
                  }
                  lesson.items?.forEach((activity) => {
                    if (activity['item-code'] == activityCode) {
                      lessonNode.items.push({
                        name: activity.name,
                        'item-type': 'resource',
                        'item-code': activityCode,
                      });
                      if(!isScorableActivityPresent) {
                        isScorableActivityPresent = this.isActivityScorable(activity);
                      }
                    }
                  })
                }
              })
            }
            return (unit['item-code'] == unitCode);
          })
        }
      })
      entity.itemsArray = JSON.parse(JSON.stringify(entity.items));
      entity.items = tree;
      entity.isScorableActivityPresent = isScorableActivityPresent;
    })
    //sorting the custom links in alphabetical order
    this.customSortIgnoreCase(this.customLinks);
  }

  private isActivityScorable(activity: any): boolean {
    // if activity['sub-type'] is "ext-cup-scompscoreable", then treat it as a non-scorable activity else check using ContentHelper.isTestContent function
    return activity['sub-type'] === 'ext-cup-scompscoreable' ? false : ContentHelper.isTestContent(activity);
  }

  onClickManageCustomLinksBtn() {
    this.manageCustomLinks = true;
  }

  selectCustomLink(customLink){
    this.selectedCustomLink = customLink;
  }

  toggleSideBar() {
    return this.ltiAssignmentsSharedService.toggleSideBar(this);
  }
  launchActivity(activityItem) {
    return this.ltiAssignmentsSharedService.launchActivity(activityItem, this);
  }  
  changeCardBgColor(event) {
    return this.ltiAssignmentsSharedService.changeCardBgColor(event, this);
  }
  startLoader() {
    return this.ltiAssignmentsSharedService.startLoader(this);
  }
  setAssignment() {
      this.noOfCheckedItemsChange.emit(this.noOfCheckedItems);
      this.tocArrayChange.emit(this.tocArray);
  }
  markItemsCheckBoxState(valueToBeSet: boolean, lessonItem: any, unit:any) {
    if(!this.unitActivityCountHash.hasOwnProperty(unit['item-code'])){
      this.unitActivityCountHash[unit['item-code']] = 0;
    }
    for (const item of lessonItem.items ) {
      if (!item.isChecked && valueToBeSet) {
        this.noOfCheckedItems += 1;
        this.unitActivityCountHash[unit['item-code']]+=1;
        if (this.tocFolderDepth > 0) lessonItem.checkedItems++;
        if (this.tocFolderDepth > 1) unit.checkedItems += 1;
      }
      if (item.isChecked && !valueToBeSet) {
        // Update assignment LO count if user is in custom link journey
        this.assignmentsLOCount--;
        this.noOfCheckedItems -= 1;
        this.unitActivityCountHash[unit['item-code']]-=1;
        if (this.tocFolderDepth > 0) lessonItem.checkedItems--;
        if (this.tocFolderDepth > 1) unit.checkedItems -= 1;
      }
      item.isChecked = valueToBeSet;
    }
  }

  onChangeItemCheckBox($event, item, lessonItem, unit) {
    if(!this.unitActivityCountHash.hasOwnProperty(unit['item-code'])){
      this.unitActivityCountHash[unit['item-code']] = 0;
    }
    if ($event.currentTarget.checked) {

      // Check if the current flow is an assignment journey and the assignments LO limit is reached  
      if (this.assignmentsLOCount >= this.assignmentsLOLimitInClass) {
        // Uncheck the checkbox and set the value of isChecked to false
        $event.target.checked = false;
        item.isChecked = false;
        // Trigger the warning modal to notify the user about the limit  
        this.assignmentsLOLimitWarningModalButton.nativeElement.click();
        return;
      }
      // Increment the assignments LO count if it is an assignment journey  
      this.assignmentsLOCount++;
      this.noOfCheckedItems++;
      lessonItem.checkedItems++;
      this.unitActivityCountHash[unit['item-code']]++;
      if (this.tocFolderDepth > 1) unit.checkedItems++;
    } else {
      // Decrease the LO Count
      this.assignmentsLOCount--;
      this.noOfCheckedItems--;
      lessonItem.checkedItems--;
      this.unitActivityCountHash[unit['item-code']]--;
      if (this.tocFolderDepth > 1) unit.checkedItems--;
    }
  }
  selectUnitItems($event, unitItem) {
    unitItem.isUnitChecked = $event.currentTarget.checked;
    if ($event.currentTarget.checked) {
      this.noOfCheckedUnits++;
    }
    else {
      this.noOfCheckedUnits--;
    }
  }

  selectLessonAllItems($event, lessonItem, unit) {
    return this.ltiAssignmentsSharedService.selectLessonAllItems($event, lessonItem, unit, this);
  }

  // Select all units for deep link creation
  // In case of Level 1 Speaking companion, we get items of type resource
  selectAllUnits($event) {
    for (const unit of this.tocArray) {
      if(unit['item-type'] === 'folder' || unit['item-type'] === 'resource') {
        if(unit.isUnitChecked != $event.currentTarget.checked) {
          this.selectUnitItems($event, unit);
        }
      }
    }
  }

  // Function to add multiple test at once in LTI Deeplinking Mode
  // This function also handles Level 1 Speaking Companion deeplink creation.
  onChangeTestItemCheckBox($event, activity) {
    if(this.isSpeakingCompanion) {
      if(this.deeplinkOption === 'unit') {
        this.selectUnitItems($event, activity);
      } else {
        this.onChangeScompCustomLinkCheckBox($event, activity, activity);
      }
    } else {
      if ($event.target.checked) {
        activity.isChecked = true;
        this.selectedTestActivities.push(activity);
        this.noOfCheckedUnits++;
      } else {
        //remove activity from selectedTestActivities array
        if (this.selectedTestActivities.length > 0) {
          let testActivityIndex = this.selectedTestActivities.findIndex(testActivity => activity['item-code'] === testActivity['item-code']);
          this.selectedTestActivities.splice(testActivityIndex, 1);
        }
        activity.isChecked = false;
        this.noOfCheckedUnits--;
      }
    }
  }

  // Function to create Custom Deeplink selected for Speaking Companion for Level 1 and 2
  onChangeScompCustomLinkCheckBox($event, activity, unit) {
      const activityAtFirstLevel = unit['item-type'] === 'resource';
      // Initialize hash if needed (for custom mode)
      if(!activityAtFirstLevel && !this.unitActivityCountHash.hasOwnProperty(unit['item-code'])){
        this.unitActivityCountHash[unit['item-code']] = 0;
      }
      
      if ($event.target.checked) {
        if (this.assignmentsLOCount >= this.assignmentsLOLimitInClass) {
          $event.target.checked = false;
          activity.isChecked = false;
          this.assignmentsLOLimitWarningModalButton.nativeElement.click();
          return;
        }
        activity.isChecked = true;
        this.assignmentsLOCount++;
        this.noOfCheckedItems++;
        // Increment unit Activity hash count when activity is not at first level and activity is checked
        if(!activityAtFirstLevel) {
          this.unitActivityCountHash[unit['item-code']]++;
        }
      } else { 
        activity.isChecked = false;
        this.assignmentsLOCount--;
        this.noOfCheckedItems--;
        // Decrement unit Activity hash count when activity is not at first level and activity is made unchecked
        if(!activityAtFirstLevel) {
          this.unitActivityCountHash[unit['item-code']]--;
        }
      }
  }
  
  /* TO BE REMOVED IF NEMO-1277 is discarded
  public isAbsoluteUrl(url) {
    let pat = /(^https?:\/\/)|(^\/\/)/i;
    return pat.test(url);
  }*/

  private getRouteParams() {
    let {spaceid, classid, productcode} = this.activatedRoute.snapshot.params;
    return {spaceId:spaceid, classId: classid, productcode: productcode}
  }

  // Navigate to class app based on no of assignable components.
  navigateBack() {
    const routeParams = this.getRouteParams();
    let ltik = this.activatedRoute.snapshot.queryParams['ltik'];
    this.appHelperService.navigateToOnboardingApp(['lti-component-selection', routeParams['spaceId'], 'class', routeParams['classId'], 'bundle', this.productBundleDetails['bundle-code'], 'resource', 'deeplink', 'ltik', ltik]);
    return true;
  }

  relinkDeeplink(selectedCustomLink) {
    let isScorableActivityPresent = selectedCustomLink?.isScorableActivityPresent;

    if(this.classmeta?.ext_data?.lti_cloned) {
      this.requestDeepLinkingForm(selectedCustomLink.ext_assigned_path_id, selectedCustomLink.title, isScorableActivityPresent);
    } else {
      this.requestDeepLinkingForm(selectedCustomLink.assigned_path_id, selectedCustomLink.title, isScorableActivityPresent);
    }
  }

  //Get autoSubmitting Deeplinking form
  requestDeepLinkingForm(assignmentPathID = undefined,title = undefined, isScorableActivityPresent = false) {
    let ltik = this.activatedRoute.snapshot.queryParams['ltik'];

    if (ltik) {
      this.showDeepLinkLoader = true;
      const routeParams = this.getRouteParams();
      let resourceData = [];
      let resourceObject = {
        "type": "ltiResourceLink",
        "window": {
        },
        "icon": {
          "url": PERM_CACHED_ASSETS_BASEPATH + "img/lti_dl_icon.png",
          "width": 100,
          "height": 100
        },
        "thumbnail": {
          "url": PERM_CACHED_ASSETS_BASEPATH + "img/lti_dl_thumbnail.png",
          "width": 90,
          "height": 90
        }
      }
      if (assignmentPathID != undefined) {
        let queryStr = "?resource=" + encodeURIComponent(`c1/assignment/${this.productBundleDetails['bundle-code']}/${routeParams['productcode']}/${assignmentPathID}`);

        resourceObject["title"] = title;
        resourceObject["text"] = title;
        // If a scoreable activity(containing LO's) is present, then there's no grade returned for the links.
        if(isScorableActivityPresent) {
          resourceObject["lineItem"] = {
            label: title,
            scoreMaximum: 100
          }
        }
        resourceObject["url"] = `https://${GATEWAY_TOOL_DOMAIN}/v1/lti/launch${queryStr}`;
        resourceData.push(JSON.parse(JSON.stringify(resourceObject)));
      } else if (this.selectedTestActivities && this.selectedTestActivities.length > 0) {
        this.selectedTestActivities.forEach(testActivity => {
          let itemCode = decodeURIComponent(testActivity['item-code']);
          let queryStr = "?resource=" + encodeURIComponent(`c1/activity/${this.productBundleDetails['bundle-code']}/${routeParams['productcode']}/${itemCode}`);

          resourceObject["title"] = `${this.productBundleDetails.title}, ${this.classProduct.meta.title}, ${testActivity.name}`;
          resourceObject["text"] = `${this.productBundleDetails.title}, ${this.classProduct.meta.title}, ${testActivity.name}`;
          resourceObject["lineItem"] = {
            label: `${this.productBundleDetails.title}, ${this.classProduct.meta.title}, ${testActivity.name}`,
            scoreMaximum: 100
          }
          resourceObject["url"] = `https://${GATEWAY_TOOL_DOMAIN}/v1/lti/launch${queryStr}`;
          resourceData.push(JSON.parse(JSON.stringify(resourceObject)));
        });
      } else {
        let selectedItems = [];
        this.tocArray.forEach(unit => {
          if (unit.isUnitChecked) {
            const activityItems = this.productTocService.getLeafNodeItems(unit);
            const isScorableActivityPresent = activityItems.some(item =>
              // if item['sub-type'] is "ext-cup-scompscoreable", then treat it as a non-scorable activity else check using ContentHelper.isTestContent function
              (item['sub-type'] && item['sub-type'] === 'ext-cup-scompscoreable') ? false : ContentHelper.isTestContent(item)
            );
            selectedItems.push({
              ...unit,
              isScorableActivityPresent
            });
          }
        });
        if (selectedItems.length) {
          //Currently handled for only 1st item selected
          selectedItems.forEach((selectedItem) => {
            let newResourceObject = JSON.parse(JSON.stringify(resourceObject));
            let queryStr = "?resource=" + encodeURIComponent(`c1/unit/${this.productBundleDetails['bundle-code']}/${routeParams['productcode']}/${selectedItem['item-code']}`);
            newResourceObject["title"] = `${this.productBundleDetails.title}, ${this.classProduct.meta.title}, ${selectedItem.name}`;
            newResourceObject["text"] = `${this.productBundleDetails.title}, ${this.classProduct.meta.title}, ${selectedItem.name}`;
            if(selectedItem.isScorableActivityPresent) {
              newResourceObject["lineItem"] = {
                label: `${this.productBundleDetails.title}, ${this.classProduct.meta.title}, ${selectedItem.name}`,
                scoreMaximum: 100
              }
            }
            newResourceObject["url"] = `https://${GATEWAY_TOOL_DOMAIN}/v1/lti/launch${queryStr}`;
            resourceData.push(newResourceObject);
          })
        }
      }
      this.ltiHelperService.requestDeepLinkingForm(ltik, resourceData).then((res: any) => {

        if (res.errorType == 'toolUnauthorized') {
          this.appHelperService.navigateToOnboardingApp(['lti-onboarding-error', 'toolUnauthorized']);
        } else {
          this.showDeepLinkLoader = false;
          $('body').append(res.form);
        }
      }).catch((error) => {
        this.appHelperService.navigateToOnboardingApp(['lti-error']);
      });
    }
  }

  onTooltipKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Esc') {
        (event.target as HTMLElement).blur();
    }
  }
}
